import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/shared/services/common.service';
import { UtilitiesService } from 'src/app/shared/services/utilities.service';
import { AcIndex, GeneralIndex, LcIndex, FQIndex } from './calculation.const';

@Injectable({
  providedIn: 'root',
})
export class ContractExpectationCalculationService {
  private formularyData = ['NA'];
  private tempArray = [];
  private lastQuarterIndexTemp: number;

  constructor(
    private commonService: CommonService,
    private utilitiesService: UtilitiesService
  ) {}

  public updateTrxCalculationAllQuarter(
    unitsFromCreateScenario,
    perCapitaAllData,
    adoptionCurveMonthSelected,
    adoptionCurveMonthJson,
    adoptionSelectedValue,
    userDefinedData,
    modelimpact
  ) {
    this.tempArray = [];
    let unitsAllQuarterValue: any;
    const clientIndexes = userDefinedData.flatMap((prd, idx) => prd.base.IsCompanyProduct ? [idx] : []);
    const isPPCDealValueEmpty = clientIndexes.some(prdIdx => this.utilitiesService.checkZeroOrEmptyString(perCapitaAllData.tableData.deal.limitedColumns[prdIdx][LcIndex.ppc].value));

    if (isPPCDealValueEmpty) {
      unitsAllQuarterValue = this.updateDealAndNoDealUnits(
        unitsFromCreateScenario,
        perCapitaAllData,
        'deal',
        adoptionCurveMonthSelected,
        adoptionCurveMonthJson,
        adoptionSelectedValue,
        userDefinedData,
        modelimpact
      );
    } else {
      unitsAllQuarterValue = perCapitaAllData;
    }
    this.tempArray = [];

    const isPPCNoDealValueEmpty = clientIndexes.some(prdIdx => this.utilitiesService.checkZeroOrEmptyString(perCapitaAllData.tableData.noDeal.limitedColumns[prdIdx][LcIndex.ppc].value))

    if (isPPCNoDealValueEmpty) {
      unitsAllQuarterValue = this.updateDealAndNoDealUnits(
        unitsFromCreateScenario,
        perCapitaAllData,
        'noDeal',
        adoptionCurveMonthSelected,
        adoptionCurveMonthJson,
        adoptionSelectedValue,
        userDefinedData,
        modelimpact
      );
    } else {
      unitsAllQuarterValue = perCapitaAllData;
    }
    if (isPPCDealValueEmpty || isPPCNoDealValueEmpty) {
      unitsAllQuarterValue = this.updateTrxPercentageCalculationAllQuarter(perCapitaAllData);
    } else {
      unitsAllQuarterValue = perCapitaAllData;
    }
    return unitsAllQuarterValue;
  }

  private updateDealAndNoDealUnits(
    unitsFromCreateScenario,
    perCapitaAllData,
    type,
    adoptionCurveMonthSelected,
    adoptionCurveMonthJson,
    adoptionSelectedValue,
    userDefinedData?,
    modelimpact?
  ) {
    const firstQuarter = this.getQuarter(unitsFromCreateScenario.contractPeriod.ContractStartDate);
    const lastQuarter = this.getQuarter(unitsFromCreateScenario.contractPeriod.ContractEndDate);

    const compProdLength = userDefinedData.filter((prd) => !prd.base.IsCompanyProduct).length;

    const adoptionList = userDefinedData.map((prd,prdIdx) => {
      if(prd.base.IsCompanyProduct){
        return this.adoptionCurveCalculation(
         firstQuarter,
         lastQuarter,
         perCapitaAllData,
         type,
         adoptionCurveMonthSelected[prdIdx].data,
         adoptionCurveMonthJson,
         adoptionSelectedValue[prdIdx].data);
      }else{
        return [];
      }
    })

    let totalSourceAllocation = 0;
    let sourceAllocationUpdatedValue = 0;

    const firstQuarterIndex = perCapitaAllData.units[type].heading.indexOf(firstQuarter);
    const lastQuarterIndex = perCapitaAllData.units[type].heading.indexOf(lastQuarter);
    this.lastQuarterIndexTemp = lastQuarterIndex;

    if (Array.isArray(userDefinedData)) {
      userDefinedData.forEach((udRow) => {
        if (!udRow?.base?.IsCompanyProduct) {
          const saVal = udRow?.[type]?.Source;
          totalSourceAllocation += (saVal === '' || saVal === undefined || saVal === null || isNaN(parseFloat(saVal))) ? 0 : parseFloat(saVal);
        }
      });
    }

    const useFairShare = totalSourceAllocation === 0;
    let sourceAllocationQuarterly: number[][] = [];

    if (useFairShare) {
      const totalQuarters = perCapitaAllData.units[type].heading.length;
      sourceAllocationQuarterly = this.fairShareAllocation(
        perCapitaAllData,
        type,
        1,              // Start from first quarter in data
        totalQuarters,  // End at last quarter in data
        userDefinedData
      );
      
    }

    perCapitaAllData.units[type].tableData.map((unitDealRow, unitDealIndex) => {
      // client product
      if (userDefinedData[unitDealIndex].base.IsCompanyProduct) {
        unitDealRow.map(
          (unitsDealInnerRow, unitDealInnerIndex, unitDealInnerArray) => {
            // between first quarter and last quarter (exclusive: last quarter is pinned to snapshot below)
            if (unitDealInnerIndex >= firstQuarterIndex && unitDealInnerIndex < lastQuarterIndex) {
              const parameter = {
                perCapitaAllData,
                unitDealIndex,
                unitDealInnerIndex,
                type,
                lastQuarter,
                adoptionList: adoptionList[unitDealIndex],
                firstQuarter,
                modelimpact
              };

              this.calculateClientUnitData(parameter, unitDealInnerArray);

            } else if (unitDealInnerIndex === lastQuarterIndex) {
              // Pin last quarter to the allColumns snapshot so it matches the per-capita baseline table exactly.
              unitDealInnerArray[unitDealInnerIndex].value = perCapitaAllData.tableData[type].allColumns[unitDealIndex][AcIndex.units].value;
            }
          }
        );
      }
    });

    if (totalSourceAllocation === 0) {
      // Fair-share path: per quarter, independent per competitor.
      for (let quarterIndex = firstQuarterIndex; quarterIndex <= lastQuarterIndex; quarterIndex++) {
        userDefinedData.forEach((prd, unitDealIndex) => {
          if (!prd.base.IsCompanyProduct) {
            const sourceAllocationFraction = sourceAllocationQuarterly[unitDealIndex][quarterIndex];
            const mpi = perCapitaAllData.tableData[type].allColumns[unitDealIndex][AcIndex.mpi].value / 100;
            const parameter = {
              unitDealInnerArray: perCapitaAllData.units[type].tableData[unitDealIndex],
              unitDealInnerIndex: quarterIndex,
              perCapitaAllData,
              unitDealIndex,
              type,
              sourceAllocationUpdatedValue: sourceAllocationFraction,
              mpi,
            };
            this.calculateCompetitorData(parameter, userDefinedData);
          }
        });

        // Pin last-quarter competitor values to snapshot
        userDefinedData.forEach((prd, unitDealIndex) => {
          if (!prd.base.IsCompanyProduct) {
            const lastQuarterIdx = perCapitaAllData.units[type].heading.indexOf(lastQuarter);
            if (quarterIndex === lastQuarterIdx) {
              perCapitaAllData.units[type].tableData[unitDealIndex][quarterIndex].value =
                perCapitaAllData.tableData[type].allColumns[unitDealIndex][AcIndex.units].value;
            }
          }
        });
      }
    } else {
      // SA path: process each client brand in full (all contract quarters) before the next brand.
      // Brand N extracts from competitor state already reduced by Brands 1..N-1.

      // Step 1: reset competitors to baseline so Brand 1 always starts clean.
      for (let qIdx = firstQuarterIndex; qIdx < lastQuarterIndex; qIdx++) {
        userDefinedData.forEach((prd, unitDealIndex) => {
          if (!prd.base.IsCompanyProduct) {
            perCapitaAllData.units[type].tableData[unitDealIndex][qIdx].value =
              perCapitaAllData.units.baseline.tableData[unitDealIndex][qIdx].value;
          }
        });
      }

      // Step 2: for each brand, run all quarters sequentially.
      userDefinedData.forEach((prd, prdIdx) => {
        if (!prd.base.IsCompanyProduct) { return; }
        for (let quarterIndex = firstQuarterIndex; quarterIndex < lastQuarterIndex; quarterIndex++) {
          this.extractBrandFromCompetitors(perCapitaAllData, type, quarterIndex, prdIdx, userDefinedData);
        }
      });

      // Step 3: pin last-quarter competitor values to allColumns snapshot.
      const lastQuarterIdx = perCapitaAllData.units[type].heading.indexOf(lastQuarter);
      userDefinedData.forEach((prd, unitDealIndex) => {
        if (!prd.base.IsCompanyProduct) {
          perCapitaAllData.units[type].tableData[unitDealIndex][lastQuarterIdx].value =
            perCapitaAllData.tableData[type].allColumns[unitDealIndex][AcIndex.units].value;
        }
      });
    }

    this.adjustUnits(perCapitaAllData, type);
    // this.adjustSA(perCapitaAllData, type);
    this.adjustMPI(perCapitaAllData, type, userDefinedData);
    this.calculateTrx(perCapitaAllData, type);
    return perCapitaAllData;
  }

  /**
   * Extracts ONE brand's impact from competitors for a single quarter.
   * Competitors are initialised from units[type].tableData (not baseline),
   * so each brand sees the market already reduced by all previously processed brands.
   */
  private extractBrandFromCompetitors(
    perCapitaAllData: any,
    type: string,
    quarterIndex: number,
    brandIndex: number,
    userDefinedData: any[]
  ): void {
    // Read current (post-previous-brand) competitor units from the live table.
    const competitors: { index: number; saFraction: number; available: number }[] = [];
    userDefinedData.forEach((prd, unitDealIndex) => {
      if (!prd.base.IsCompanyProduct) {
        const saRaw = userDefinedData[unitDealIndex]?.[type]?.Source;
        const saFraction = (saRaw === '' || saRaw === undefined || saRaw === null || isNaN(parseFloat(saRaw)) ? 0 : parseFloat(saRaw)) / 100;
        const current = perCapitaAllData.units[type].tableData[unitDealIndex][quarterIndex].value;
        competitors.push({
          index: unitDealIndex,
          saFraction,
          available: Math.max(0, typeof current === 'number' ? current : 0),
        });
      }
    });

    const actualClientUnits = perCapitaAllData.units[type].tableData[brandIndex][quarterIndex].value;
    const baselineClientUnits = perCapitaAllData.units.baseline.tableData[brandIndex][quarterIndex].value;
    const clientDelta = actualClientUnits - baselineClientUnits;

    if (clientDelta <= 0) {
      for (const c of competitors) {
        c.available += (-clientDelta) * c.saFraction;
      }
    } else {
      // Pass 1: SA-weighted extraction capped at available.
      let shortfall = 0;
      for (const c of competitors) {
        const requested = clientDelta * c.saFraction;
        const actual = Math.min(Math.max(0, requested), c.available);
        c.available -= actual;
        shortfall += Math.max(0, requested - actual);
      }

      // Pass 2+: fair-share redistribution of shortfall.
      const maxPasses = competitors.length + 1;
      let passCount = 0;
      while (shortfall > 1e-6 && passCount++ < maxPasses) {
        const eligible = competitors.filter(c => c.available > 1e-6);
        if (eligible.length === 0) { break; }
        const totalAvailable = eligible.reduce((sum, c) => sum + c.available, 0);
        if (totalAvailable <= 1e-6) { break; }
        let newShortfall = 0;
        for (const c of eligible) {
          const fraction = c.available / totalAvailable;
          const requested = shortfall * fraction;
          const actual = Math.min(requested, c.available);
          c.available -= actual;
          newShortfall += requested - actual;
        }
        shortfall = newShortfall;
      }
      // Uncoverable shortfall discarded; client keeps adoption-curve units.
    }

    // Write final competitor values back.
    for (const c of competitors) {
      perCapitaAllData.units[type].tableData[c.index][quarterIndex].value =
        this.utilitiesService.ifNullThenZero(c.available);
    }
  }

  // new logic(Fixed code keep it)
  private calculateClientUnitData(parameter, unitDealInnerArray) {
    const {
      perCapitaAllData,
      unitDealIndex,
      unitDealInnerIndex,
      type,
      lastQuarter,
      adoptionList,
      firstQuarter,
      modelimpact
    } = parameter;

    // Current quarter's baseline units
    const baselineUnits = perCapitaAllData.units.baseline.tableData[unitDealIndex][unitDealInnerIndex].value;

    const finalQuarterBaselinePatientCount = perCapitaAllData.finalQuarterData.data[unitDealIndex][FQIndex.patient].value;
    
    // Use user-entered PPP from limitedColumns (not the calculated output in allColumns)
    const ppcValue = perCapitaAllData.tableData[type].limitedColumns[unitDealIndex][LcIndex.ppc].value;
    let peakPatientPercentage = 0;
    if(modelimpact[type] == 'Peak Patient Count'){
        peakPatientPercentage = this.utilitiesService.forPercentage(
        ((ppcValue / finalQuarterBaselinePatientCount) - 1) * 100
      );
    }else{
      peakPatientPercentage = ppcValue;
    }

    // Calculate impact for current quarter: baselineUnits * (1 + PPC/100)
    const unitsWithImpact = baselineUnits * (1 + peakPatientPercentage / 100);

    // Current quarter's baseline units (same as baselineUnits, but explicit for clarity)
    const currentQuarterBaselineUnits = perCapitaAllData.units.baseline.tableData[unitDealIndex][unitDealInnerIndex].value;

    // Get adoption curve for current quarter
    const firstQuarterIndex = perCapitaAllData.units[type].heading.indexOf(firstQuarter);
    const adoptionCurve = adoptionList[unitDealInnerIndex - firstQuarterIndex];

    // Calculate adjustment: (unitsWithImpact - currentQuarterBaselineUnits) * adoptionCurve%
    // Which simplifies to: (baselineUnits * impact - baselineUnits) * adoptionCurve%
    const temp = (unitsWithImpact - currentQuarterBaselineUnits) * (adoptionCurve / 100);

    // Final units calculation
    const units = baselineUnits + temp;

    unitDealInnerArray[unitDealInnerIndex].value = this.utilitiesService.ifNullThenZero(units);
  }

  private calculateCompetitorData({
    unitDealInnerArray,
    unitDealInnerIndex,
    perCapitaAllData,
    unitDealIndex,
    type,
    sourceAllocationUpdatedValue,
    mpi,
  },userDefinedData) {
    const baselineUnits = perCapitaAllData.units.baseline.tableData[unitDealIndex][unitDealInnerIndex].value;

    let totalUnits = baselineUnits;
    userDefinedData.forEach((prd, prdIdx) => {
      if(prd.base.IsCompanyProduct){
        const actualClientUnits = perCapitaAllData.units[type].tableData[prdIdx][unitDealInnerIndex].value;
        const baselineClientUnits = perCapitaAllData.units.baseline.tableData[prdIdx][unitDealInnerIndex].value;
        const units = ((actualClientUnits - baselineClientUnits) * sourceAllocationUpdatedValue);
        totalUnits -= units;

        // Negative values for competitor products
        if (totalUnits < 0) {
          if (!this.tempArray[unitDealIndex]) {
            this.tempArray[unitDealIndex] = [];
          }
        
          if (!this.tempArray[unitDealIndex][unitDealInnerIndex]) {
            this.tempArray[unitDealIndex][unitDealInnerIndex] = [];
          }
        
          if (!this.tempArray[unitDealIndex][unitDealInnerIndex][prdIdx]) {
            this.tempArray[unitDealIndex][unitDealInnerIndex][prdIdx] = this.utilitiesService.roundOff(totalUnits);
          } else {
            this.tempArray[unitDealIndex][unitDealInnerIndex][prdIdx] +=this.utilitiesService.roundOff(totalUnits);
          }
        }
      }
    })

    unitDealInnerArray[unitDealInnerIndex].value = this.utilitiesService.ifNullThenZero(totalUnits);

  }

  /**
   * Processes all SA-weighted competitors for a single quarter.
   *
   * For multi-brand scenarios each client brand is processed SEQUENTIALLY so that
   * Brand N extracts from the market state left by Brands 1…N-1. This mirrors the
   * baseline service's `computeSACompetitorUnitsIterative` which uses
   * `isFirstBrandPass` to switch between FQ-baseline and current allColumns state.
   *
   * Per brand (adoption-curve impact already reflected in units[type].tableData):
   *   • clientDelta > 0 (client gains):
   *       Pass 1 – SA-weighted extraction capped at each competitor's remaining units.
   *       Pass 2+ – fair-share redistribution of shortfall among non-exhausted competitors.
   *       Truly uncoverable shortfall → tempArray reduces that brand's client units.
   *   • clientDelta ≤ 0 (client loses): competitors gain proportionally (no cap needed).
   */
  private calculateAllCompetitorsForQuarter(
    perCapitaAllData: any,
    type: string,
    quarterIndex: number,
    userDefinedData: any[]
  ): void {
    // Build competitor state from baseline units once for this quarter.
    // `available` is updated in-place as each client brand extracts sequentially.
    const competitors: { index: number; saFraction: number; available: number }[] = [];
    userDefinedData.forEach((prd, unitDealIndex) => {
      if (!prd.base.IsCompanyProduct) {
        const saRaw = userDefinedData[unitDealIndex]?.[type]?.Source;
        const saFraction = (saRaw === '' || saRaw === undefined || saRaw === null || isNaN(parseFloat(saRaw)) ? 0 : parseFloat(saRaw)) / 100;
        const baselineUnits = perCapitaAllData.units.baseline.tableData[unitDealIndex][quarterIndex].value;
        competitors.push({
          index: unitDealIndex,
          saFraction,
          available: Math.max(0, baselineUnits),
        });
      }
    });

    // Process each client brand in order — each sees the market after previous brands.
    userDefinedData.forEach((prd, prdIdx) => {
      if (!prd.base.IsCompanyProduct) { return; }

      const actualClientUnits = perCapitaAllData.units[type].tableData[prdIdx][quarterIndex].value;
      const baselineClientUnits = perCapitaAllData.units.baseline.tableData[prdIdx][quarterIndex].value;
      const clientDelta = actualClientUnits - baselineClientUnits;

      if (clientDelta <= 0) {
        // Client losing patients for this brand — competitors gain proportionally.
        // No exhaustion risk so no redistribution needed.
        for (const c of competitors) {
          c.available += (-clientDelta) * c.saFraction;
        }
        return;
      }

      // Pass 1: SA-weighted extraction capped at each competitor's remaining units.
      let shortfall = 0;
      for (const c of competitors) {
        const requested = clientDelta * c.saFraction;
        const actual = Math.min(Math.max(0, requested), c.available);
        c.available -= actual;
        shortfall += Math.max(0, requested - actual);
      }

      // Pass 2+: redistribute shortfall by fair share among all non-exhausted competitors.
      const maxPasses = competitors.length + 1;
      let passCount = 0;
      while (shortfall > 1e-6 && passCount++ < maxPasses) {
        const eligible = competitors.filter(c => c.available > 1e-6);
        if (eligible.length === 0) { break; }
        const totalAvailable = eligible.reduce((sum, c) => sum + c.available, 0);
        if (totalAvailable <= 1e-6) { break; }
        let newShortfall = 0;
        for (const c of eligible) {
          const fraction = c.available / totalAvailable;
          const requested = shortfall * fraction;
          const actual = Math.min(requested, c.available);
          c.available -= actual;
          newShortfall += requested - actual;
        }
        shortfall = newShortfall;
      }

      // Uncoverable shortfall is not fed back to client.
      // Competitors drain to 0; client keeps its adoption-curve units.
    });

    // Write final competitor units back after all brands have been processed.
    for (const c of competitors) {
      perCapitaAllData.units[type].tableData[c.index][quarterIndex].value =
        this.utilitiesService.ifNullThenZero(c.available);
    }
  }

  private fairShareAllocation(
    perCapitaAllData: any,
    type: string,
    firstQuarterIndex: number,
    lastQuarterIndex: number,
    userDefinedData: any[]
  ): number[][] {
    // Initialize 2D array: sourceAllocationQuarterly[competitorIndex][quarterIndex]
    const sourceAllocationQuarterly: number[][] = [];

    // Get all competitor product indices
    const competitorIndices: number[] = [];
    userDefinedData.forEach((prd, prdIdx) => {
      if (!prd.base.IsCompanyProduct) {
        competitorIndices.push(prdIdx);
      }
    });

    // If no competitors, return empty array
    if (competitorIndices.length === 0) {
      return sourceAllocationQuarterly;
    }

    // Build the fair share array for each competitor and each quarter
    userDefinedData.forEach((prd, unitDealIndex) => {
      // Only process competitor products
      if (!prd.base.IsCompanyProduct) {
        sourceAllocationQuarterly[unitDealIndex] = [];

        // Loop through each quarter in the contract period
        for (let quarterIndex = firstQuarterIndex; quarterIndex < lastQuarterIndex; quarterIndex++) {
          // Calculate total competitor scaled units for this quarter
          let totalCompetitorScaledUnits = 0;

          competitorIndices.forEach((compIdx) => {
            const scaledUnits =
              perCapitaAllData.units.baseline.tableData[compIdx][quarterIndex].value || 0;
            totalCompetitorScaledUnits += scaledUnits;
          });

          // Calculate fair share for this competitor in this quarter
          if (totalCompetitorScaledUnits === 0) {
            // Avoid division by zero - equal distribution
            sourceAllocationQuarterly[unitDealIndex][quarterIndex] =
              1 / competitorIndices.length;
          } else {
            // Fair share based on baseline scaled units
            const currentCompetitorScaledUnits =
              perCapitaAllData.units.baseline.tableData[unitDealIndex][quarterIndex].value || 0;

            const fairShare = currentCompetitorScaledUnits / totalCompetitorScaledUnits;
            sourceAllocationQuarterly[unitDealIndex][quarterIndex] = fairShare;
          }
        }
      }
    });

    return sourceAllocationQuarterly;
  }

  private adjustUnits(perCapitaAllData, type){
    perCapitaAllData.units[type].tableData.map((row, index) => {
      row.map((innerRow, innerIndex) => {
        if (this.tempArray[index]) {
          if (this.tempArray[index][innerIndex]?.length > 0) {
            this.tempArray[index][innerIndex].forEach((value,prdIdx) => {
              if (typeof value === 'number') {
                const clientUnit = perCapitaAllData.units[type].tableData[prdIdx][innerIndex].value;
                const updatedClientUnit = clientUnit + value;
                perCapitaAllData.units[type].tableData[prdIdx][innerIndex].value = updatedClientUnit;
              }
            });
          }
        }
      });
    });
  }

  private adjustMPI(perCapitaAllData, type, userDefinedData){
    perCapitaAllData.units[type].tableData.map((row, index) => {
      row.map((innerRow, innerIndex) => {
        if (userDefinedData[index].base.IsCompanyProduct) {
          return;
        }
        const mpiRaw = userDefinedData[index]?.[type]?.Impact;
        const multiProductImpact = (mpiRaw === '' || mpiRaw === undefined || mpiRaw === null || isNaN(parseFloat(mpiRaw))) ? 0 : parseFloat(mpiRaw);
        if (
          multiProductImpact !== 0 && !(this.lastQuarterIndexTemp === innerIndex)
        ) {
          const competitorUnit = perCapitaAllData.units[type].tableData[index][innerIndex].value;

          if(typeof competitorUnit !== 'number'){
            return;
          }
          const updatedMultiProductImpact = multiProductImpact / 100;

          const updatedClientUnit = perCapitaAllData.units[type].tableData.reduce((acc, curr, currIdx) => {
            if (userDefinedData[currIdx].base.IsCompanyProduct) {
              return acc + curr[innerIndex].value;
            }else{
              return acc;
            }
          }, 0);

          const baselineClientUnits = perCapitaAllData.units.baseline.tableData.reduce((acc, curr, currIdx) => {
            if (userDefinedData[currIdx].base.IsCompanyProduct) {
              return acc + curr[innerIndex].value;
            }else{
              return acc;
            }
          }, 0);

          const updatedCompetitorUnits = competitorUnit + (updatedClientUnit - baselineClientUnits) * updatedMultiProductImpact;
          
          perCapitaAllData.units[type].tableData[index][innerIndex].value =
            this.utilitiesService.ifNullThenZero(updatedCompetitorUnits);
        }
      });
    });
  }

  // private adjustSA(perCapitaAllData, type){
  //   perCapitaAllData.units[type].tableData.map((row, index) => {
  //     row.map((innerRow, innerIndex) => {
  //       if (innerIndex === 0) {
  //         return;
  //       }
  //       // for MPI
  //       const multiProductImpact =
  //         perCapitaAllData.tableData[type].allColumns[index][AcIndex.mpi].value;
  //       if (
  //         multiProductImpact !== '' &&
  //         multiProductImpact !== '0' && !(this.lastQuarterIndexTemp === innerIndex)
  //       ) {
  //         const updatedClientUnit =
  //           perCapitaAllData.units[type].tableData[0][innerIndex].value;
  //         const competitorUnit =
  //           perCapitaAllData.units[type].tableData[index][innerIndex].value;
  //         const baselineClientUnits =
  //           perCapitaAllData.units.baseline.tableData[0][innerIndex].value;
  //         const updatedMultiProductImpact =
  //           perCapitaAllData.tableData[type].allColumns[index][AcIndex.mpi]
  //             .value / 100;
  //         const updatedCompetitorUnits =
  //           competitorUnit +
  //           (updatedClientUnit - baselineClientUnits) *
  //             updatedMultiProductImpact;
  //         perCapitaAllData.units[type].tableData[index][innerIndex].value =
  //           this.utilitiesService.ifNullThenZero(updatedCompetitorUnits);
  //       }
  //     });
  //   });
  //  }

  private calculateTrx(perCapitaAllData, type) {
    perCapitaAllData.units[type].tableData.map((row, index) => {
      row.map((innerRow, innerIndex) => {
        if (innerIndex === 0) {
          return;
        }
        const unitToTrx =
          perCapitaAllData.unitsToTrx.baseline.tableData[index][innerIndex]
            .value;
        const unit =
          perCapitaAllData.units[type].tableData[index][innerIndex].value;
          if(perCapitaAllData.trx[type].heading[innerIndex] == perCapitaAllData.unitsToTrx.baseline.heading[innerIndex]){
            perCapitaAllData.trx[type].tableData[index][innerIndex].value = this.utilitiesService.ifNullThenZero(unit / unitToTrx);
          }else{
            const newIndex = perCapitaAllData.trx[type].heading.findIndex((str)=>{
              return str === perCapitaAllData.unitsToTrx.baseline.heading[innerIndex];
            })
            if(newIndex == -1){
              return null;
            }
            perCapitaAllData.trx[type].tableData[index][newIndex].value = this.utilitiesService.ifNullThenZero(unit / unitToTrx);
          }
      });
    });
  }
  private updateTrxPercentageCalculationAllQuarter(perCapitaAllData) {
    let perCapitaData: any;
    if (
      this.utilitiesService.checkZeroOrEmptyString(
        perCapitaAllData.tableData.deal.limitedColumns[GeneralIndex.client][
          LcIndex.ppc
        ].value
      )
    ) {
      perCapitaData = this.trxSharePercentage(perCapitaAllData, 'deal');
    } else {
      perCapitaAllData = this.commonService.deepCopy(perCapitaAllData);
    }
    if (
      this.utilitiesService.checkZeroOrEmptyString(
        perCapitaAllData.tableData.noDeal.limitedColumns[GeneralIndex.client][
          LcIndex.ppc
        ].value
      )
    ) {
      perCapitaData = this.trxSharePercentage(perCapitaAllData, 'noDeal');
    } else {
      perCapitaAllData = this.commonService.deepCopy(perCapitaAllData);
    }
    return perCapitaData;
  }

  private getQuarter(contractDate) {
    const date = new Date(contractDate);
    const month = date.getMonth();
    const year: any = date.getFullYear();
    let quarter: string;
    if (month <= 2) {
      quarter = 'Q1';
    } else if (month <= 5) {
      quarter = 'Q2';
    } else if (month <= 8) {
      quarter = 'Q3';
    } else {
      quarter = 'Q4';
    }
    return quarter + '-' + year.toString().slice(-2);
  }

  private adoptionCurveCalculation(
    firstQuarter,
    lastQuarter,
    perCapitaAllData,
    type,
    adoptionCurveData,
    adoptionCurveMonthJson,
    adoptionSelectedValue
  ) {
    const adoptionMonth = adoptionCurveData[type];
    const adoptionCurvePercentage = [];
    let count = 3;

    const heading = perCapitaAllData.units[type].heading;

    heading.map((row, index, array) => {
      if (
        index >= array.indexOf(firstQuarter) &&
        index <= array.indexOf(lastQuarter)
      ) {
        adoptionCurvePercentage.push(100);
      }
    });

    adoptionCurvePercentage.map((row, index, array) => {
      const condition1 = parseInt(adoptionMonth, 10) % 3 === 0;
      const uptakeArr = adoptionCurveMonthJson?.Uptake?.[adoptionMonth]?.[adoptionSelectedValue?.[type]];
      const condition2 = count < (uptakeArr?.length ?? 0);
      if (condition1 && condition2) {
        adoptionCurvePercentage[index] = uptakeArr[count - 1].y;
        count += 3;
      }
    });

    return adoptionCurvePercentage;
  }

  public getFinalQuarterData(perCapitaData) {
    const eligiblePatientList = perCapitaData.eligiblePatient.tableData.filter(
      (k) =>
        k.every(
          (e) =>
            e.value !== 'Adjusted Payer Lives' &&
            e.value !== 'Patient Eligibility Factor (%)' &&
            e.value !== 'Total Eligible Patient Count'
        )
    );
    const units = perCapitaData.units.tableData;
    const trx = perCapitaData.TRx.tableData;
    const TRxSharePercent = perCapitaData.TRxSharePercent.tableData;
    const livesToUnits = perCapitaData.livesToUnits.tableData;
    const scalingFactor = perCapitaData.scalingFactor; // need to update it
    const unitsToTrx = perCapitaData.unitsToTrx.tableData; // need to update it
    const finalArray: any = [];
    const lastQuarter = this.getQuarter(
      perCapitaData.contractPeriod.ContractEndDate
    );
    const lastQuarterIndex = perCapitaData.units.heading.indexOf(lastQuarter);
    units.forEach((element, index) => {
      finalArray.push([
        element[0],
        eligiblePatientList[index][lastQuarterIndex],
        element[lastQuarterIndex],
        TRxSharePercent[index][lastQuarterIndex],
        livesToUnits[index][lastQuarterIndex],
        {
          value: scalingFactor[lastQuarterIndex-1],
          type: 'data',
          dataType: 'number',
        },
        unitsToTrx[index][lastQuarterIndex],
        {
          value: this.formularyData[0],
          type: 'dropDown',
          dataType: 'text',
          options: this.formularyData,
        },
        trx[index][lastQuarterIndex],
      ]);
    });
    return finalArray;
  }

  private trxSharePercentage(perCapitaAllData, type) {
    const totalTrxArray = [];
    for (let i = 1; i < perCapitaAllData.trx[type].tableData[0].length; i++) {
      let totalTrx = 0;
      // tslint:disable-next-line:prefer-for-of
      for (let j = 0; j < perCapitaAllData.trx[type].tableData.length; j++) {
        totalTrx =
          totalTrx +
          parseInt(perCapitaAllData.trx[type].tableData[j][i].value, 10);
      }
      totalTrxArray.push(totalTrx);
    }

    perCapitaAllData.trxPercentage[type].tableData.map((rowData, index) => {
      rowData.map((innerRowData, innerIndex) => {
        if (innerIndex !== 0) {
          const currentTrx =
            perCapitaAllData.trx[type].tableData[index][innerIndex].value;
          const totalTrx = totalTrxArray[innerIndex - 1];
          innerRowData.value = this.utilitiesService.forPercentage(
            (currentTrx / totalTrx) * 100
          );
        }
      });
    });

    return perCapitaAllData;
  }
}
